import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// NOTE: Fetch all Landlords details
export const fetchLandlords = createAsyncThunk(
  "fetch/landlords",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`user/manage-landlords?${query}`);
    return response.data;
  }
);

// NOTE: Get User Profile
export const getUserProfile = createAsyncThunk(
  "get/user/profile",
  async (userId) => {
    const response = await api.get(`user/${userId}`);
    return response.data;
  }
);
// NOTE: create a user
export const createUser = createAsyncThunk(
  "user/profile",
  async (createData) => {
    const response = await api.post("user", createData);
    return response.data;
  }
);

// NOTE: Fetch All User Profile
export const fetchAllUsers = createAsyncThunk(
  "fetch/all-users",
  async (params = {}) => {
    const query = generateQueryParams(params);
    const response = await api.get(`user?${query}`);
    return response.data;
  }
);

// NOTE: Delete User
export const deleteUser = createAsyncThunk("delete/user", async (userId) => {
  const response = await api.delete(`user/${userId}`);
  return response.data;
});

// NOTE: Restore User Profile
export const restoreUser = createAsyncThunk("restore/user", async (userId) => {
  const response = await api.patch(`/user/restore/${userId}`);
  return response.data;
});

// Update User Profile
export const updateUser = createAsyncThunk(
  "user/update",
  async ({ id, updatedFields }) => {
    const response = await api.put(`/user/${id}`, updatedFields);
    return response.data;
  }
);
